export const TIME_RANGES = [
  { label: '24h', days: 1 },
  { label: '7d', days: 7 },
  { label: '30d', days: 30 },
] as const;

interface TimeRangeControlProps {
  value: number;
  onChange: (days: number) => void;
}

export function TimeRangeControl({ value, onChange }: TimeRangeControlProps) {
  return (
    <div role="group" aria-label="Time range" className="inline-flex rounded-md border overflow-hidden">
      {TIME_RANGES.map((r, i) => {
        const active = value === r.days;
        return (
          <button
            key={r.label}
            type="button"
            aria-pressed={active}
            onClick={() => onChange(r.days)}
            className={[
              'px-3.5 py-1.5 text-sm font-medium transition-colors',
              i > 0 ? 'border-l' : '',
              active
                ? 'bg-primary text-primary-foreground'
                : 'text-muted-foreground hover:bg-muted hover:text-foreground',
            ].join(' ')}
          >
            {r.label}
          </button>
        );
      })}
    </div>
  );
}
